<template>
	<div class="info-table">
		<div class="title-desc" v-if="title">
			{{title}}
		</div>
		<div class="table-title">
			<div class="title-item" :style="{width:item.width,flex:item.width==='flex'?'1':'none'}"
				v-for="(item,index) in titles" :key="index">
				{{item.label}}
			</div>
		</div>
		<div class="table-content" v-if="datas&&datas.length" :style="{height:height}">
			<div class="content-row" v-for="(item1,index1) in datas" :key="index1">
				<div class="row-item" :style="{width:item.width,flex:item.width==='flex'?'1':'none'}"
					v-for="(item,index) in titles" :key="'row0'+index">
					<div class="more-btn" v-if="item.key==='button'" @click="handClick(item1)">
						更多
					</div>
					<template v-else>
						{{item1[item.key]}}
					</template>
				</div>
			</div>
		</div>
		<div class="table-null" v-else>
			暂无数据
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			datas: {
				type: Array,
				default: []
			},
			titles: {
				type: Array,
				default: []
			},
			height: {
				type: String,
				default: '420px'
			},
			title: {
				type: String,
				default: ''
			}
		},
		methods: {
			handClick(e) {
				this.$emit('more', e);
			}
		}
	}
</script>

<style lang="less">
	.info-table {
		flex: 1;
		//height: 500px;
		//background: #ffffff;
		padding: 24px;
		//padding: 0px 40px;

		.title-desc {
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #1D2129;
		}

		.table-title {
			display: flex;
			flex-wrap: nowrap;
			flex: 1;

			.title-item {
				padding: 0px 12px;
				background: #E5E6EB;
				height: 40px;
				line-height: 40px;
				white-space: nowrap;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 600;
				color: #1D2129;
				display: flex;
				align-items: center;

			}
		}

		.table-content {
			width: 100%;
			height: 420px;
			overflow-y: auto;

			.content-row {
				display: flex;
				flex-wrap: nowrap;
				border-bottom: 1px solid #E5E6EB;

				.row-item {
					padding: 0px 12px;
					background: #FFFFFF;
					height: 40px;
					line-height: 40px;
					white-space: nowrap;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 500;
					color: #4E5969;
					display: flex;
					align-items: center;
					overflow-x: auto;

					.more-btn {
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						color: #00266d;
						text-decoration: underline;
						cursor: pointer;
						user-select: none;
					}
				}
			}
		}

		.table-null {
			height: 50px;
			line-height: 50px;
			text-align: center;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 500;
			color: #cccccc;
		}
	}
</style>